import { commonConfig, CommonConfigKeys } from './common.config'
import { ConfigType } from './types'

export type ProductionEnvConfigKeys = CommonConfigKeys

export const productionConfig: ConfigType = commonConfig
